// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1GcA7","content":"LoadingAlert_content__3llN_"};